import { FleetSafetySummary, FleetSafetySummaryResponse } from "../../../models";
import { getPayPeriod } from "./getPayPeriod";

const getSummary = (row: any): FleetSafetySummary => {
  const s = row.summary || {};
  return {
    driverId: row.driver_id,
    firstName: row.first_name,
    lastName: row.last_name,
    weightedScore: s.weighted_score ?? null,
    reportCount: s.report_count ?? 0,
    totalDriveMinutes: s.total_drive_minutes ?? 0,
    totalDriveMiles: s.total_drive_miles ?? 0,
  };
};

export const getFleetSafetySummary = (data: any): FleetSafetySummaryResponse => ({
  payPeriod: getPayPeriod(data.pay_period),
  summaries: (data?.summaries || []).map(getSummary),
});
